import { type SimpleChanges } from '@angular/core';
import { type Observable } from 'rxjs';

import {
  type CanvasElement,
  type CanvasElementDataInputPayload,
  type CanvasElementInput,
  type CanvasElementProperties,
  type WithProps,
} from '@blaze-runtime/engine-domain';
import {
  type CanvasElementDataProperties,
  type CanvasElementInputBinding,
  type DataBindingSourceInfo,
  type RenderElementContext,
  type RenderElementDataRowContext,
} from '@blaze-shared/elements-domain';

import { type CanvasElementDefinition } from '../../element-definition';
import { type RenderElementInstance } from '../../models/render-element.models';

export type InputDataPackage = Omit<CanvasElementDataInputPayload<any>, 'key'>;

export const isInputDataPackage = (value: unknown): value is InputDataPackage =>
  !!value && typeof value === 'object' && 'sourceType' in value && 'data' in value;

export type DataInputsReadyMap = Partial<Record<CanvasElementInputBinding, boolean>>;

export interface BindInputsConfig {
  element: CanvasElement & WithProps<CanvasElementProperties>;
  elementInputs: CanvasElementInput[];
  elementInstance: RenderElementInstance;
  elementDefinition: CanvasElementDefinition;
  elementContext$: Observable<RenderElementContext | undefined>;
  dataInitialized$: Observable<boolean>;
  componentInitialized$: Observable<boolean>;
  setComponentInput: (input: string, value: unknown) => void;
  changesNotifier: (value: SimpleChanges) => void;
  isDataContainerValueSetUpdater: () => void;
  isHiddenByBindingUpdater: (value: boolean) => void;
  dataInputsReadyUpdater: (value: DataInputsReadyMap) => void;
}

export interface DataProviderQuery {
  inputName: CanvasElementInputBinding;
  source: DataBindingSourceInfo;
  bindings: Record<string, string> | undefined;
  element: CanvasElement;
  binding: CanvasElementDataProperties | undefined;
  rowContext?: RenderElementDataRowContext;
  expression?: boolean;
}
